import { Flex, ScrollArea, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle, IconListDetails } from "@tabler/icons-react";
import clsx from "clsx";
import { AppMenuLink, NestedMenu, useAppLinks } from "components/AppMenu";
import { useTranslation } from "react-i18next";
import SideMenuFooter from "./SideMenuFooter";

interface SideMenuBarProps {}

const SideMenuBar: React.FC<SideMenuBarProps> = ({}) => {
  const { t } = useTranslation("common");

  const { mainMenuLinks, basicInfoLinks, exceptionLinks } = useAppLinks();
  const [isOpen, { open, close }] = useDisclosure();

  return (
    <Flex
      miw={isOpen ? 157 : undefined}
      direction="column"
      justify={"space-between"}
      fz={"sm"}
      tt={"uppercase"}
      visibleFrom="lg"
      c={"white"}
      className={`z-20 bg-gray-dark h-full fixed left-0 bottom-0`}
      data-testid="side-menu-bar"
      onMouseEnter={open}
      onMouseLeave={close}
    >
      <ScrollArea type="hover" pt={60}>
        <Stack fw={400} lh={1} gap={0}>
          {mainMenuLinks.map(({ link, label, icon, isActive, badge }) => (
            <AppMenuLink
              className={clsx(
                "flex items-center px-4 py-4 border-b border-[#4E4E4E]",
                "hover:text-yellow",
                {
                  "text-yellow": isActive,
                }
              )}
              key={label}
              link={link}
              label={label}
              icon={icon}
              badge={badge}
              showLabel={isOpen}
            />
          ))}

          {(basicInfoLinks.length > 0 || exceptionLinks.length > 0) && (
            <NestedMenu
              isVisible={isOpen}
              className="w-full border-b border-[#4E4E4E] px-4 py-4"
              label={t("basicInformation")}
              icon={<IconListDetails className="shrink-0" />}
            >
              {basicInfoLinks.map(({ link, label, icon, isActive }) => (
                <AppMenuLink
                  className={clsx(
                    "flex items-center pl-9 pr-4 py-3 border-b border-[#4E4E4E]",
                    "hover:text-yellow",
                    {
                      "text-yellow": isActive,
                    }
                  )}
                  key={label}
                  link={link}
                  label={label}
                  icon={icon}
                />
              ))}
              {exceptionLinks.length > 0 && (
                <NestedMenu
                  isVisible={isOpen}
                  className="w-full pl-9 pr-4 py-3 border-b border-[#4E4E4E]"
                  label={t("damages")}
                  icon={<IconAlertCircle className="shrink-0" />}
                >
                  {exceptionLinks.map(({ link, label, icon, isActive }) => (
                    <AppMenuLink
                      className={clsx(
                        "flex items-center pl-12 pr-4 py-3 border-b border-[#4E4E4E]",
                        "hover:text-yellow",
                        {
                          "text-yellow": isActive,
                        }
                      )}
                      key={label}
                      link={link}
                      label={label}
                      icon={icon}
                    />
                  ))}
                </NestedMenu>
              )}
            </NestedMenu>
          )}
        </Stack>
      </ScrollArea>

      <SideMenuFooter isOpen={isOpen} />
    </Flex>
  );
};

export default SideMenuBar;
